import type { ReactNode } from 'react'

import type { jsx } from '@emotion/react'
import { FormProvider } from 'react-hook-form'
import type { UseFormReturn } from 'react-hook-form'

import * as styles from './form.styles'
import type { CastedSubmitHandler } from './types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type InputValues = Record<string, any>

type Props<T extends InputValues> = {
  children: ReactNode
  onSubmit?: CastedSubmitHandler<T>
  nativeFormProps?: jsx.JSX.IntrinsicElements['form']
  testId?: string
} & UseFormReturn<T>

export const Form = <T extends InputValues>({
  children,
  onSubmit,
  nativeFormProps,
  testId = 'form',
  ...formContext
}: Props<T>) => {
  const handleSubmit: CastedSubmitHandler<T> = async (values) => {
    if (onSubmit) {
      await onSubmit(values)
    }
  }

  return (
    <FormProvider {...formContext}>
      <form
        noValidate
        data-testid={testId}
        onSubmit={formContext.handleSubmit(handleSubmit)}
        {...nativeFormProps}
        css={[styles.form, nativeFormProps?.css]}
      >
        {children}
      </form>
    </FormProvider>
  )
}
